import { HStack } from '@montel/montelpro-shared-components-v2';
import { styled } from 'styled-components';

export const ProductIconList = styled(HStack)`
	height: 50px;
`;
